import { CsvWriter } from "./CsvWriter";
import { download } from "./utilities";
export class CsvExport {
  constructor(options = {}) {
    this._options = Object.assign({ delimiter: ",", filename: "export.csv", contentType: "text/csv", headers: {}, includeHeaders: true }, options);
  }
  createCsvBlob(data) {
    const { headers, includeHeaders, columns } = this._options;
    const writer = new CsvWriter(this._options);
    const props = columns || Object.getOwnPropertyNames(data[0]);
    if (includeHeaders) {
      writer.createRow();
      props.forEach(prop => writer.pushValue(headers[prop] || prop));
    }
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      writer.createRow();
      props.forEach(prop => writer.pushValue(row[prop]));
    }
    return writer.toBlob();
  }
  downloadCsv(data) {
    if (!data) {
      throw new Error("No data provided. File would be empty.");
    }
    const { filename } = this._options;
    const blob = this.createCsvBlob(data);
    download(blob, filename);
  }
  static create(options = {}) { return new CsvExport(options); }
  static download(data) { return new CsvExport({}).downloadCsv(data); }
}



// WEBPACK FOOTER //
// ./src/common/CSVExport/CsvExport.js